import { promoActivatedRewardStorageKey } from 'pi-kiosk-shared/promo/promoSessionHandoff';
import type { PromoLineAdjustmentDTO } from '../promotions/promoRewardsApi.js';

const RECEIPT_SNAPSHOT_PREFIX = 'promo:receiptSnapshot:';

export interface PromoReceiptAdjustmentSnapshot extends PromoLineAdjustmentDTO {
  readonly eventName?: string;
}

export interface PromoReceiptSnapshot {
  readonly paymentId: string;
  readonly adjustments: readonly PromoReceiptAdjustmentSnapshot[];
  readonly cartDiscountAmount: number;
}

export function savePromoReceiptSnapshot(
  tenantCode: string,
  paymentId: string,
  snapshot: Omit<PromoReceiptSnapshot, 'paymentId'>,
): void {
  if (typeof sessionStorage === 'undefined') {
    return;
  }
  try {
    sessionStorage.setItem(
      `${RECEIPT_SNAPSHOT_PREFIX}${tenantCode}:${paymentId}`,
      JSON.stringify({ paymentId, ...snapshot }),
    );
  } catch {
    // sessionStorage may be unavailable in private mode
  }
}

export function readPromoReceiptSnapshot(
  tenantCode: string,
  paymentId: string,
): PromoReceiptSnapshot | null {
  if (typeof sessionStorage === 'undefined') {
    return null;
  }
  try {
    const raw = sessionStorage.getItem(`${RECEIPT_SNAPSHOT_PREFIX}${tenantCode}:${paymentId}`);
    if (raw == null || raw.length === 0) {
      return null;
    }
    const parsed = JSON.parse(raw) as PromoReceiptSnapshot;
    if (parsed.paymentId !== paymentId || !Array.isArray(parsed.adjustments)) {
      return null;
    }
    return parsed;
  } catch {
    return null;
  }
}

export function clearPromoReceiptSnapshot(tenantCode: string, paymentId: string): void {
  if (typeof sessionStorage === 'undefined') {
    return;
  }
  try {
    sessionStorage.removeItem(`${RECEIPT_SNAPSHOT_PREFIX}${tenantCode}:${paymentId}`);
    sessionStorage.removeItem(promoActivatedRewardStorageKey(tenantCode, paymentId));
  } catch {
    // sessionStorage may be unavailable in private mode
  }
}
